var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isShow)?_c('div',{ref:"countDialog",staticClass:"dialog_content",on:{"click":_vm.clickToHidden}},[_c('div',{staticClass:"count_time_content"},[_c('p',{staticClass:"tip"},[_vm._v("[温馨提示]目前已经长时间没有操作设备，即将自动返回主页面。如需继续使用，请在倒计时结束前进行操作！")]),_c('p',{staticClass:"time"},[_vm._v(_vm._s(_vm.time))])]),_c('div',{staticClass:"bg"})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }